import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./SubscribeforUpdates.module.sass";
import sendEmail from "../../send_email";
import { useForm } from "react-hook-form";
import { BsConeStriped } from "react-icons/bs";
import { GlobalContext } from "../../GlobalContext";
import { useContext } from "react";
export default function SubscribeforUpdates() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [msg, setMsg] = useState();
  const [err, seterr] = useState("");
  // const [eventName, setEventName] = useState("");
  const { secondaryColor, eventName, eventYear, eventCode } =
    useContext(GlobalContext);
  const [baseUrl, setbaseUrl] = useState(null);
  useEffect(() => {
    // getEventName();
    const baseUrl = window.location.origin;
    setbaseUrl(baseUrl);
  }, []);

  // const getEventName = () => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_SERVER_URL}/event-details`)
  //     .then((response) => {
  //       setEventName(response.data[0].value);
  //     });
  // };

  const submitUpdateSubscriber = async (e) => {
    try {
      await axios
        .post(`${process.env.REACT_APP_API_SERVER_URL}/update-subscriber`, {
          name: name,
          email: null,
        })
        .then((res) => {
          if (res.status == 200) {
            let html2 = "";
            html2 += "<h4>Thank you for subscribing!</h4>";
            html2 +=
              "<p><span style='font-weight: 700'>Email:</span> " +
              email +
              "</p>";
            html2 += `<p style="font-weight: 700"><span style="text-decoration: underline">Quick Access</span><br> Link: <a style="font-weight: 500" taget="_blank" href="${baseUrl}">${baseUrl}</a></p>`;

            sendEmail(
              html2,
              `SUBSCRIPTION: ${eventName + " " + eventYear}`,
              
            );
            let html = "";
            html +=
              "<p>The following user has subscirbed for the newsletter.</p>";
            html +=
              "<p><span style='font-weight: 700'>Email:</span> " +
              email +
              "</p>";
            html += `<p style="font-weight: 700"><span style="text-decoration: underline">Quick Access</span><br> Link: <a style="font-weight: 500" taget="_blank" href="${baseUrl}">${baseUrl}</a></p>`;
            sendEmail(html, `SUBSCRIBE: ${eventName + " " + eventYear}`);

            setName("");
            setEmail("");
            setMsg("Subscribed Successfully");
          }
        });
      setTimeout(() => {
        setMsg();
      }, 4000);
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  return (
    <>
      <div className={styles.updatesContainer}>
        <div>
          <div>
            <h2>SUBSCRIBE FOR UPDATES</h2>
            <p>
              By submitting, you agree to receive email communications from the
              event organizers, including upcoming promotions and discounted
              tickets, new, and access to related events.
            </p>
            <form
              className={`${eventCode}_${eventYear}_subscribe_form row g-3 needs-validation subForm form_${eventCode}`}
              onSubmit={handleSubmit(submitUpdateSubscriber)}
              encType="multipart/form-data"
              method="POST"
            >
              <div className={styles.from}>
                <input
                  placeholder="Name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                <div>
                  <input
                    {...register("email", {
                      required: true,
                      pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                    })}
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                  {errors.email && (
                    <p className={styles.error}>
                      {email.length <= 0
                        ? "Email address is required"
                        : "Email address is invalid"}
                    </p>
                  )}
                </div>
                <button type="submit">Join</button>
              </div>
            </form>
            {msg && msg.length > 0 ? (
              <p
                style={{
                  color: "green",
                }}
              >
                {msg}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
